import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "snackbar flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  width: "30",
  height: "30",
  src: "/ico/info.svg"
}, null, -1)
const _hoisted_3 = {
  class: "flex align-center grow",
  style: {"white-space":"nowrap"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}